import { render, staticRenderFns } from "./VaccinationRecord.vue?vue&type=template&id=009cb8ea&scoped=true&"
import script from "./VaccinationRecord.vue?vue&type=script&lang=js&"
export * from "./VaccinationRecord.vue?vue&type=script&lang=js&"
import style0 from "./VaccinationRecord.vue?vue&type=style&index=0&id=009cb8ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009cb8ea",
  null
  
)

export default component.exports